const $$splitComponentImporter = () => import('/src/src/routes/_cms/cms/review/comment_moderation.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_cms/cms/review/comment_moderation")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Comment Moderation",
      description: "Page title for CMS comment moderation"
    })
  }
});